import { RootState } from 'reduxStore/types';

export const getOrdersState = (state: RootState) => state?.orders;
